import { NavigationSubItem } from "../navigation-item"

export class BlogMoreSubItem extends NavigationSubItem {
  readonly id = "blog"
  readonly label = "Blog"
  readonly href = "/blog"
  readonly iconName = "blog-icon"
  readonly isExternal = false
  readonly tabs = []
}
